<template>
    <div class="privacy-policy">
      <h1>【蛛网X】App 隐私政策</h1>
  
      <h2>个人信息收集和使用</h2>
      <ul>
        <li>注册信息：为了使用我们的App，您需要使用手机号码进行注册。我们将收集您提供的手机号码，并用于注册和登录功能。</li>
        <li>视频下载：当您下载视频并保存到相册时，我们可能需要获取相册访问权限，以便将视频保存到您的设备相册中。</li>
        <li>日志信息：我们的App可能会自动收集一些日志信息，包括设备信息、操作记录和使用习惯，用于分析和改进我们的服务。</li>

      </ul>
  
      <h2>信息保护</h2>
      <p>我们非常重视您的个人信息保护。我们会采取合理的安全措施来保护您的个人信息，防止未经授权的访问、泄露或滥用。</p>
<h2>【剪贴板信息】</h2> <p>我们的应用不会在后台持续或高频率读取您的剪贴板信息。</p> <p>仅在您主动触发相关功能时（例如点击“粘贴”按钮）才会读取一次剪贴板内容，用于便捷地识别您复制的文本或链接，以帮助您快速完成输入。</p> <p>我们不会以超过必要的频率读取您的剪贴板信息，且剪贴板内容不会被上传至服务器或用于与功能无关的用途。</p> <p>您可以自由选择是否使用“粘贴”功能，若不使用，我们将不会访问您的剪贴板。</p>
      <h2>第三方服务</h2>
      <p>我们可能使用第三方服务提供某些功能，这些服务可能会收集和使用您的一些信息。这些第三方服务供应商的信息收集和使用将受其自己的隐私政策约束。我们鼓励您查阅这些供应商的隐私政策以了解其信息处理做法。</p>
  
      <h2>权限</h2>
      <p>为了让App正常运行，我们可能需要获取您设备上的一些权限，包括但不限于存储访问和相册访问权限。您可以随时在设备设置中更改或撤销这些权限。</p>
      <h2>录音权限</h2>
      <p>当您录制带有声音的视频时，我们会使用录音权限来同步录制音频和视频。录制的数据仅用于您个人存储或分享，不会被存储或用于其他目的</p>
      <h2>相机权限</h2>
      <p>当您需要拍摄照片或视频并上传到我们的应用时，我们会使用相机权限。所拍摄的照片和视频仅用于上传，不会被存储或用于其他目的。</p>
      
      <h2>安全措施</h2>
      <p>我们采取合理的技术和组织措施，保护您的个人信息免受未经授权的访问、使用或泄露。然而，由于互联网的开放性和不确定性，我们不能保证信息的绝对安全。</p>
      <h2>注销账号</h2>
      <p>您可以通过路径:“我的-设置-账号注销”注销您的蛛网X账号。
在您注销蛛网X账号后，我们将停止为您提供蛛网X账号的全部产品和/或服务，并依据法律法规相关要求通过匿名化等方式处理您的个人信息，或删除与您账号相关的个人信息，但法律法规或监管机构对用户信息存储时间另有规定的除外。</p>
  
      <h2>未成年人隐私保护</h2>
      <p>我们不会有意收集未满法定年龄的儿童个人信息。如果您是未成年人，请在您父母或监护人的指导下使用我们的应用。</p>
  
      <h2>隐私政策的更新</h2>
      <p>我们保留随时修改本隐私政策的权利。更新的隐私政策将在App上发布，并在生效前通知用户。</p>
  
      <h2>联系我们</h2>
      <p>如果您对我们的隐私政策或个人信息有任何疑问、意见或投诉，请通过以下方式联系我们：<br>QQ:1971715546<br>邮箱:17320177064@163.com<br>杭州初六科技有限公司</p>
        
      <h2>法律依据</h2>
      <p>本隐私政策将受到适用法律的约束和解释，并根据适用法律进行解释和执行。</p>
      <p><strong>本隐私政策于 2025 年 4 月 14 日发布并生效。</strong></p>

      <!-- <h2>日期：2023.08.01</h2> -->
    </div>
  </template>
  
  <script>
  export default {
    created() {
        document.title = "隐私协议"

    },
    name: 'PrivacyPolicy',
  };
  </script>
  
  <style scoped>
  .privacy-policy {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    margin: 20px;
    text-align: left;
  }
  
  h1 {
    color: #000000;
  }
  
  h2 {
    color: #333;
  }
  
  p {
    margin-bottom: 10px;
    text-align: left;
  }
  
  ul {
    list-style-type: disc;
    padding-left: 20px;
    text-align: left;
  }
  </style>
  